import type { Progress } from '@/domain/session'
import { mmss } from '@/lib/format'
import { SectionHead } from './InfoSections'
import styles from './panel.module.css'

const dayMonth = (iso: string): string =>
  new Date(iso).toLocaleDateString('es-ES', { day: '2-digit', month: 'short' })

/** Las sesiones ya guardadas, de la más reciente a la más antigua. */
export function HistoryLog({ progress }: { progress: Progress }) {
  if (progress.sessions.length === 0) return null

  const sessions = [...progress.sessions].sort((a, b) => b.completedAt.localeCompare(a.completedAt))

  return (
    <section className={styles.section}>
      <SectionHead title="Tu registro" note={sessions.length === 1 ? '1 sesión' : `${sessions.length} sesiones`} />
      {sessions.map((session) => (
        <div key={session.id} className={styles.log}>
          <span className={styles.logDate}>
            {dayMonth(session.completedAt)} · S{session.weekNumber}
          </span>
          <span className={styles.logMark}>
            {session.rounds} rondas + {session.reps} reps
            {session.afapSeconds !== null && ` · AFAP ${mmss(session.afapSeconds)}`}
          </span>
          {session.crewBonus && <span className={styles.logBonus}>×2</span>}
        </div>
      ))}
    </section>
  )
}
